import { BitrixUser, FavoriteProduct } from '@services/AuthService/query/loadUserQuery';

/**
 * Дефолтный пользователь для случая
 * когда получаемого нет и выключена
 * обязательная авторизация в env
 */
export class DefaultUser implements BitrixUser {
  public id: string = '0';
  public transport_requests_per_month: number = 0;
  public favourites: FavoriteProduct[] = [];
  public archive: FavoriteProduct[] = [];
}
